module.exports = __webpack_public_path__ + "img/unlockcloseicon.65e15ffa.svg";